    import { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Modal from 'react-modal';
import { useLocation, useNavigate } from "react-router-dom";
import Select from 'react-select';
import 'react-toggle/style.css';
import Swal from "sweetalert2";
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";

    function ViewManifest() {
        const navigate=useNavigate()
        const location=useLocation();
        //  const [rowsPerPage, setRowsPerPage] = useState(10);
        const [totalRecords, setTotalRecords] = useState(0);
        const [loading, setLoading] = useState(true);
        const [openRow, setOpenRow] = useState(null);
        const [error, setError] = useState(null);
        const formatDate = (date) => date ? date.toISOString().split("T")[0] : null;
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const [getCity, setGetCity] = useState([]);
        const [getManifestData, setGetManifestData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [showModal, setShowModal] = useState(false);
        const [deleteInput, setDeleteInput] = useState({ manifestNo: "", docketNo: "" ,Branch_Code:""});
        const [isLoading, setIsLoading] = useState(false);
        const [rowsPerPage, setRowsPerPage] = useState(10);
        const [formValues, setFormValues] = useState({
            manifestNo: '',
            manifestDest: '',
            fromDate: firstDayOfMonth,
            toDate: today,
        });
        const extractArray = (res) => {
            if (Array.isArray(res?.Data)) return res.Data;
            if (Array.isArray(res?.data)) return res.data;
            return [];
        };
        const handleDateChange = (date, field) => {
            setFormValues({ ...formValues, [field]: date });
        };

        const handleInputChange = (e) => {
            const { name, value } = e.target;
            setFormValues({
                ...formValues,
                [name]: value
            });
        };

        const fetchData = async (endpoint, params,showPopup = true) => {
  try {
    const response = await getApi(endpoint, { params });
    const manifestData = response.Data || [];

    if (response.status === 1) {
      setGetManifestData(manifestData);

      if (showPopup) {
        Swal.fire("Success", "Manifest Data fetched successfully", "success");
      }

    } else {
      setGetManifestData([]);

      if (showPopup) {
        Swal.fire({
          icon: 'warning',
          title: 'No Data Found',
          text: 'No data available for the selected date range.',
        });
      }
    }

  } catch (err) {
    console.error('Fetch Manifest Error:', err);
    setGetManifestData([]);
  }
};
           const handleSubmit = (e,showPopup = true) => {
            e.preventDefault();
  const params = {
    sessionLocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
    manifestNo: formValues.manifestNo,
    manifestDest: formValues.manifestDest,
    fromDate: formValues.fromDate,
    toDate: formValues.toDate,
    pageNumber: currentPage,
    pageSize: rowsPerPage
  };

  fetchData('/Manifest/viewManifestData', params, showPopup);
};

        const fetchDataC = async (endpoint) => {
            try {
                const response = await getApi(endpoint);
                setGetCity(extractArray(response));
            } catch (err) {
                console.error('Fetch Error:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        useEffect(() => {
            fetchDataC('/Master/getdomestic');
        }, []);


        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = getManifestData.slice(indexOfFirstRow, indexOfLastRow);
        const totalPages = Math.ceil(getManifestData.length / rowsPerPage);
        console.log(currentPage);
        const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
        const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
        

       const handleDelete = async (e) => {
        e.preventDefault();
  try {
    if (!deleteInput.manifestNo) {
      return Swal.fire({
        icon: "warning",
        title: "Missing",
        text: "Manifest No is required!",
      });
    }

    // Confirmation popup
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this manifest!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (!confirm.isConfirmed) return;
    // API call
    const response = await postApi(
      `/Manifest/deleteManifest?sessionLocationCode=${deleteInput?.Branch_Code}&DocketNo=${deleteInput.docketNo || ""}&manifestNo=${deleteInput.manifestNo}`,
      {}
    );

    if (response.status === 1) {
      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: response.message,
      });

      // Reset modal state
      setDeleteInput({
        docketNo: "",
        manifestNo: "",
        Branch_Code: "",
      });

     setShowModal(false);
     handleSubmit(e,false);

      // 🔁 Optional: refresh data
      // fetchManifest();
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message,
      });
    }

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: error.message,
    });
  }
};
      
const handleDeleteInputChange = (e) => {
            const { name, value } = e.target;
            setDeleteInput({ ...deleteInput, [name]: value });
        };

       
        const handleOpenManifestPrint = (manifestData) => {
        navigate("/manifest",{state:{data:manifestData,from: location.pathname}});
        };
        return (
            <>
                <div className="body">
                    <div className="container1">
                        <form action="" onSubmit={handleSubmit}>
                            <div className="fields2" >
                                <div className="input-field3">
                                    <label htmlFor="">Manifest No</label>
                                    <input type="tel" className="input" placeholder="Manifest No" value={formValues.manifestNo}
                                        onChange={handleInputChange} name="manifestNo" />
                                </div>

                                <div className="input-field3">
                                    <label htmlFor="">Destination</label>
                                    <Select
                                        options={getCity.map(city => ({
                                            value: city.City_Code,   // adjust keys from your API
                                            label: city.City_Name
                                        }))}
                                        value={
                                            formValues.manifestDest
                                                ? { value: formValues.manifestDest, label: getCity.find(c => c.City_Code === formValues.manifestDest)?.City_Name || "" }
                                                : null
                                        }
                                        onChange={(selectedOption) =>
                                            setFormValues({
                                                ...formValues,
                                                manifestDest: selectedOption ? selectedOption.value : ""
                                            })
                                        }
                                        placeholder="Select Destination"
                                        isSearchable
                                        classNamePrefix="blue-selectbooking"
                                        className="blue-selectbooking"
                                        menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                                        styles={{
                                            placeholder: (base) => ({
                                                ...base,
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }),
                                            menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                                        }}
                                    />
                                </div>


                                <div className="input-field3">
                                    <label htmlFor="">From</label>
                                    <DatePicker
                                        portalId="root-portal"
                                        selected={formValues.fromDate}
                                        onChange={(date) => handleDateChange(date, "fromDate")}
                                        dateFormat="dd/MM/yyyy"
                                        
                                    />
                                </div>

                                <div className="input-field3">
                                    <label htmlFor="">To</label>
                                    <DatePicker
                                        portalId="root-portal"
                                        selected={formValues.toDate}
                                        onChange={(date) => handleDateChange(date, "toDate")}
                                        dateFormat="dd/MM/yyyy"
                                        
                                    />
                                </div>

                                <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                                    <button className="ok-btn"  type="submit">Submit</button>
                                </div>
                            </div>

                        </form>

                       

                        {isLoading ? (<div className="loader"></div>) : (
                            <div className='table-container'>
                                <table className='table table-bordered table-sm' style={{whiteSpace:"nowrap"}}>
                                    <thead>
                                    <tr>
                                    <th className="w-60">Actions</th>
                                    <th className="w-60">Sr.No</th>
                                    <th>Branch.Code</th>
                                    <th>Branch.Name</th>
                                    <th>Manifest.No</th>
                                    <th>Manifest.Date</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Vendor.Name</th>
                                    <th>Dkt.Count</th>
                                    <th>Mode</th>
                                    <th>Qty</th>
                                    <th>Weight</th>
                                    <th>Vehicle.No</th>
                                    <th>Driver.Name</th>
                                    <th>Driver.Mobile</th>
                                    <th>Remark</th>
                                </tr>
                                    </thead>

                                    <tbody>
                                        {getManifestData.map((manifest, index) => (
                                            <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                                <td className="w-60">
                                                    <PiDotsThreeOutlineVerticalFill
                                                        style={{ fontSize: "20px", cursor: "pointer" }}
                                                        onClick={() =>
                                                            setOpenRow(openRow === index ? null : index) // toggle only this row
                                                        }
                                                    />

                                                    {openRow === index && (
                                                        <div
                                                            style={{
                                                                        display: "flex",
                                                        justifyContent: "center",
                                                        flexDirection: "row",
                                                        position: "absolute",
                                                        alignItems: "center",
                                                        left: "63px",
                                                        top: "1px",
                                                        borderRadius: "10px",
                                                        backgroundColor: "white",
                                                        zIndex: "999999",
                                                        height: "24px",
                                                        width: "70px",
                                                        padding: "10px",
                                                            }}
                                                        >
                                                            <button
                                                                className="edit-btn"
                                                        
                                                                onClick={() => handleOpenManifestPrint(manifest)}
                                                            >
                                                                <i
                                                                    className="bi bi-file-earmark-pdf-fill"
                                                                    
                                                                ></i>
                                                            </button>
                                                            <button 
                                                            className="edit-btn"
                                                            
                                                             onClick={() => {
    setShowModal(true);
    setOpenRow(null);
    setDeleteInput({
      Branch_Code: manifest.Branch_Code,     // make sure this exists
      manifestNo: manifest.manifestNo,
    });
  }}
                                                            >
                                                                <i className="bi bi-trash"></i>
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                        <td className="w-60">{index + 1}</td>
                                        <td>{manifest.Branch_Code}</td>
                                        <td>{manifest.Branch_Name}</td>
                                        <td>{manifest.manifestNo}</td>
                                        <td>{manifest.manifestDt}</td>
                                        <td>{manifest.fromDest}</td>
                                        <td>{manifest.toDest}</td>
                                        <td>{manifest.Vendor_Name}</td>
                                        <td>{manifest.shipment}</td>
                                        <td>{manifest.Mode_Name}</td>
                                        <td>{manifest.sumQty}</td>
                                        <td>{manifest.sumActualWt}</td>
                                        <td>{manifest.vehicleNo}</td>
                                        <td>{manifest.driverName}</td>
                                        <td>{manifest.driverMobile}</td>
                                        <td>{manifest.Remark}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>)}

                        <div className="row" style={{ whiteSpace: "nowrap" }}>
            <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
              <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                {'<'}
              </button>
              <span style={{ color: "#333", padding: "5px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                {'>'}
              </button>
            </div>

            <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
              <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
              <select
                id="rowsPerPage"
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}

                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
              >
                <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
              </select>
            </div>
          </div>


                        <Modal overlayClassName="custom-overlay" isOpen={showModal}
                            className="custom-modal-gst" contentLabel="Modal">
                            <div className="custom-modal-content">
                                <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                                    <header style={{ width: "95%", textAlign: "center" }}>Delete Manifest Data</header>
                                    <button className="ok-btn" style={{ width: "40px", height: "100%", backgroundColor: "red" }}
                                        onClick={() => setShowModal(false)}>
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                                <div className='container2' style={{ padding: "20px" }}>

                                    <form action="" style={{ backgroundColor: "white" }}>
                                        <div className="fields2">
                                            <div className="input-field">
                                                <label>Manifest No:</label>
                                                <input
                                                    type="text"
                                                    name="manifestNo"
                                                    readOnly
                                                    value={deleteInput.manifestNo}
                                                    onChange={handleDeleteInputChange}
                                                    placeholder="Enter Manifest No"
                                                />
                                            </div>

                                            <div className="input-field">
                                                <label>Docket No:</label>
                                                <input
                                                    type="text"
                                                    name="docketNo"
                                                    value={deleteInput.docketNo}
                                                    onChange={handleDeleteInputChange}
                                                    placeholder="Enter Docket No"
                                                />
                                            </div>
                                        </div>

                                        <div className="bottom-buttons">
                                            <button className="ok-btn" type="button" onClick={handleDelete}>Delete</button>
                                            <button className="ok-btn" type="button" onClick={() => setShowModal(false)}>Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal >
                    </div>
                </div>
            </>
        );
    };

    export default ViewManifest;